export default __webpack_public_path__ + "static/media/success-tick.5f747380.svg";